import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: '首页 (Home)',
    href: '#'
  }, {
    name: '服务 (Services)',
    href: '#services'
  }, {
    name: '关于我们 (About)',
    href: '#about'
  }, {
    name: '评价 (Reviews)',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#FDF8F0]/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="flex justify-between items-center" data-id="element-237">
          {/* Logo */}
          <div className="flex items-center" data-id="element-238">
            <a href="#" className="text-2xl font-serif font-bold text-[#2D5A3D]" data-id="element-239">
              新加坡爽吧 <span className="text-[#C9A96E]" data-id="element-240">Shiok8</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-241">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#2D2D2D] hover:text-[#2D5A3D] transition-colors text-sm font-medium" data-id="element-242">
                {link.name}
              </a>)}
            <button className="bg-[#2D5A3D] hover:bg-[#1e3d29] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors duration-300 shadow-lg hover:shadow-xl" data-id="element-243">
              立即预约 (Book Now)
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-244">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#2D5A3D] p-2" data-id="element-245">
              {isMobileMenuOpen ? <X size={24} data-id="element-246" /> : <Menu size={24} data-id="element-247" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-248">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FDF8F0] border-t border-[#D4B483]/20" data-id="element-249">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-250">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-[#2D2D2D] hover:text-[#2D5A3D] hover:bg-[#F5EDE0] rounded-md" data-id="element-251">
                  {link.name}
                </a>)}
              <div className="pt-4" data-id="element-252">
                <button className="w-full bg-[#2D5A3D] text-white px-6 py-3 rounded-md text-base font-medium" data-id="element-253">
                  立即预约 (Book Now)
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}